import RedactionSearchResultsContainer from './RedactionSearchResultsContainer';

export default RedactionSearchResultsContainer;